import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  isErrored: boolean;
  isValidated: boolean;
};
export const ImageValidationStatus = ({ className, isErrored, isValidated }: Props) => (
  <Fragment>
    {isErrored && (
      <Icon
        className={classnames('pointer-events-none text-red', className)}
        name={ICONS.CROSS}
        width="0.8125rem"
      />
    )}
    {isValidated && (
      <Icon
        className={classnames('pointer-events-none text-success', className)}
        name={ICONS.CHECK}
        width="0.8125rem"
      />
    )}
  </Fragment>
);
